import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Industries } from "@/components/site/Industries";
import { Services } from "@/components/site/Services";
import { LicentieChecker } from "@/components/site/LicentieChecker";
import { Manifesto } from "@/components/site/Manifesto";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="App bg-white">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Industries />
        <Services />
        <LicentieChecker />
        <Manifesto />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
